



















import { NotificationType } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class BaseIcon extends Vue {
  @Prop({ required: true })
  icon!: string;

  @Prop({ required: false, default: "" })
  size!: "2x" | "3x" | "4x" | "5x";

  @Prop({ required: false, default: "" })
  align!: "left" | "right" | "";

  @Prop({ required: false, default: false })
  fixedWidth!: boolean;

  @Prop({ required: false, default: false })
  spin!: boolean;

  @Prop({ required: false, default: "" })
  screenReaderLabel!: string;

  @Prop({ required: false, default: "" })
  iconToolTip!: string;

  @Prop({ required: false, default: false })
  padRight!: boolean;

  @Prop({ required: false, default: NotificationType.DEFAULT })
  issueType!: NotificationType;

  hover = false;

  get iconName() {
    return `fa-${this.icon}`;
  }

  get iconSize() {
    return this.size ? `fa-${this.size}` : "";
  }

  get iconSpin() {
    return this.spin ? "fa-spin" : "";
  }

  get iconFixedWidth() {
    return this.fixedWidth ? "fa-fw" : "";
  }

  get iconAlign() {
    return this.align === "" ? "" : `align-${this.align}`;
  }

  get iconWrapPadRight() {
    return this.padRight ? "pad-right" : "";
  }
}
